import {
  chainDynamicValue,
  DynamicValue,
  useComponentState,
} from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Card,
  Col,
  Form,
} from "react-bootstrap";
import Heading from "src/components/Heading";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import onChangeToValue from "src/functions/onChangeToValue";
import onChangeToValueCheckbox from "src/functions/onChangeToValueCheckbox";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sNote } from "src/styles/sNote.module.scss";
import { DataJoinUsForm } from "src/types/DataJoinUsForm";

type Props = { formData: DynamicValue<DataJoinUsForm> };

function FormJoinUsSites({ formData }: Props) {
  var toggleAccordion = useComponentState(false);
  return (
    <Accordion
      defaultActiveKey={`1`}
      className={composeClassNames([sFormAccordion, "joinus-sites"])}
    >
      <Card>
        <AccordionToggle eventKey={`0`}>
          <Heading
            type={`h2`}
            title={
              <>
                {`3. `}
                <Translate tKey={`Sites`} />
                <Text size={`md`} width={`regular`}>
                  {`1 `}
                  <Translate tKey={`min.`} />
                </Text>
              </>
            }
          />
        </AccordionToggle>
        <AccordionCollapse eventKey={`0`}>
          <Card.Body>
            <Form.Row>
              <Col sm={8} xs={12}>
                <Form.Group>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Website`} />
                  </Form.Label>
                  <Form.Control
                    className={sFormControl}
                    name={`website`}
                    id={`website`}
                    onChange={function (param2) {
                      return chainDynamicValue(formData, "website").change(
                        onChangeToValue(param2)
                      );
                    }}
                    value={chainDynamicValue(formData, "website").value}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col sm={8} xs={12}>
                <Form.Group>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Facebook profile`} />
                  </Form.Label>
                  <Form.Control
                    className={sFormControl}
                    name={`facebook`}
                    id={`facebook`}
                    onChange={function (param2) {
                      return chainDynamicValue(formData, "facebook").change(
                        onChangeToValue(param2)
                      );
                    }}
                    value={chainDynamicValue(formData, "facebook").value}
                  />
                </Form.Group>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col sm={8} xs={12}>
                <Form.Group>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Instagram profile`} />
                  </Form.Label>
                  <Form.Control
                    className={sFormControl}
                    name={`instagram`}
                    id={`instagram`}
                    onChange={function (param2) {
                      return chainDynamicValue(formData, "instagram").change(
                        onChangeToValue(param2)
                      );
                    }}
                    value={chainDynamicValue(formData, "instagram").value}
                  />
                </Form.Group>
                <Form.Check>
                  <Form.Check.Input
                    className={sFormControl}
                    name={`instagram-implement`}
                    id={`instagram-implement`}
                    onChange={function (param2) {
                      return chainDynamicValue(
                        formData,
                        "instagram-implement"
                      ).change(onChangeToValueCheckbox(param2));
                    }}
                    value={
                      chainDynamicValue(formData, "instagram-implement").value
                    }
                  />
                  <Form.Check.Label className={sFormLabel}>
                    <Translate tKey={`Implement the Instagram gallery`} />
                  </Form.Check.Label>
                </Form.Check>
                <Form.Text className={sNote}>
                  <Translate
                    tKey={`If you check this option, the latest Instagram photos will be displayed on your profile.`}
                  />
                </Form.Text>
              </Col>
            </Form.Row>
          </Card.Body>
        </AccordionCollapse>
      </Card>
    </Accordion>
  );
}

export default FormJoinUsSites;
